import { Box, Grid, Typography } from "@mui/material";
import LabelPrinter from "../../../../../../../components/LabelPrinter";
import { useFormContext } from "react-hook-form";
import { useMemo, useState } from "react";
import { Moment } from "moment";
import DialogSelecionarData from "./DialogSelecionarData";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../../lib/axios";
import { IDataListaTitulosPagar } from "../../../../../../../types/api/financeiro/pesquisar-titulos-pagar";
import LoadingApiQuery from "../../../../../../../components/LoadingApiQuery";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";

export default function TitulosSelecionados() {

  //Form context
  const { getValues, setValue, watch } = useFormContext();

  const dataReceb = getValues('finalizacao.data_pagamento')
  const titulosSelecionados = watch('selecionar_titulos')
  //
  const [modalDataRecb, setModalDataRecb] = useState(false)
  const [dataRecebimento, setDataRecebimento] = useState<Moment>(dataReceb)

  //queries e mutations
  const { data, isLoading } = useQuery({
    queryKey: ['titulosSelecionados', titulosSelecionados],
    queryFn: () => axiosClient.get('/financeiro/contas-pagar/pesquisar-titulos-pagar', {
      params: {
        ids: titulosSelecionados.map((item: IDataListaTitulosPagar) => item.id)
      }
    }),
    enabled: titulosSelecionados.length > 0,
    onSuccess: (data) => {
      const dados: IDataListaTitulosPagar[] = data.data.data
      const valorTotal = dados.reduce((acc, item) => acc + item.saldo_principal, 0)
      setValue('total', valorTotal)
    }
  })
  const titulosPagar: IDataListaTitulosPagar[] = useMemo(() => data?.data.data || [], [data])
  //

  //Funções manipuladoras
  const handleChangeData = (data: Moment) => {
    setValue('finalizacao.data_pagamento', data)
    setDataRecebimento(data)
  }
  //

  const total = useMemo(() => titulosPagar.reduce((acc, item) => acc + item.saldo_principal, 0), [titulosPagar])

  return (
    <>
      <Box
        p={3}
        borderRadius={1}
        bgcolor={'#f5f5f5'}
        width={650}
        height={{ md: "unset", lg: 200 }}
        boxShadow={2}
      >
        <Box>
          <Typography mb={5} variant='h6'>Títulos selecionados</Typography>
        </Box>
        {
          isLoading && <LoadingApiQuery />
        }

        {
          !isLoading &&
            <Grid container spacing={1} rowGap={1}>
              <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                <LabelPrinter size="small" titulo='Qtd. títulos' valor={titulosPagar.length.toString()} />
              </Grid>

              <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                <LabelPrinter size="small" titulo='Saldo total' valor={formatarValorMonetario(total)} />
              </Grid>

              <Grid size={{ xs: 6, md: 6, lg: 4 }}>
                <LabelPrinter
                  size="small"
                  titulo='Data do pagamento'
                  valor={dataReceb.format("DD/MM/YYYY")}
                  editavel={true}
                  editAcao={() => setModalDataRecb(true)}
                />
              </Grid>
            </Grid>
        }
      </Box>

      {
        modalDataRecb &&
        <DialogSelecionarData
          open={modalDataRecb}
          handleClose={() => setModalDataRecb(false)}
          defValue={dataRecebimento}
          onChange={(value: Moment) => handleChangeData(value)}
        />
      }
    </>
  )
}
